import { on } from '@ember/modifier';
import { t } from 'ember-intl';
import styles from './contact-list-item.module.scss';

<template>
  <li
    class="{{styles.component}} contact-list-item"
    data-test-contact={{@contact.id}}
    data-test-contact-list-item
    ...attributes
  >
    <button
      type="button"
      class="item-button"
      data-test-contact-list-item-button
      {{on "click" @onClick}}
      aria-label={{t "emc.contact_list_item.select_aria_label" userNames=@userNames}}
    >
      {{yield}}
    </button>
  </li>
</template>
